module.exports = __webpack_public_path__ + "img/tom-alby.fd318862.jpg";